import { Type } from 'typebox';
export const SleepCheckPositions = {
    back: 'back',
    tummy: 'tummy',
    leftSide: 'side (L)',
    rightSide: 'side (R)'
};
export const SleepCheckPosition = Type.Union([
    Type.Literal(SleepCheckPositions.back),
    Type.Literal(SleepCheckPositions.tummy),
    Type.Literal(SleepCheckPositions.leftSide),
    Type.Literal(SleepCheckPositions.rightSide)
]);
export const SleepCheckDetail = Type.Object({
    note: Type.Optional(Type.String()),
    position: Type.Optional(SleepCheckPosition),
    actor: Type.Optional(Type.String({ minLength: 1 })),
    time: Type.Optional(Type.Number())
});
